import * as Icons from "lucide-react";
import { DIFFERENTIALS, COMPANY } from "../lib/constants";

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="py-20 md:py-32 bg-[#F5F7FA] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(47,88,135,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(47,88,135,0.6) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7 reveal">
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-[#00C7A5] mb-4">
              Por que escolher a Master Business
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2F5887] leading-tight">
              Diferenciais que fazem do seu dia a dia mais leve e estratégico
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-[#4B5563] text-lg leading-relaxed">
              Combinamos profundidade técnica e proximidade real com cada cliente, oferecendo muito mais do que uma assessoria contábil tradicional.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {DIFFERENTIALS.map((d, i) => {
            const Icon = Icons[d.icon] || Icons.CheckCircle;
            return (
              <div
                key={i}
                data-testid={`differential-card-${i}`}
                className="reveal group relative bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-transparent hover:border-[#00C7A5]/30"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#2F5887] to-[#00C7A5] flex items-center justify-center shadow-md group-hover:scale-110 transition-transform">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-[#111111] mb-2 group-hover:text-[#2F5887] transition-colors">
                      {d.title}
                    </h3>
                    <p className="text-[#4B5563] leading-relaxed text-[15px]">{d.desc}</p>
                  </div>
                </div>

                {/* Number watermark */}
                <span className="absolute bottom-4 right-5 text-5xl font-bold font-display text-[#F5F7FA] group-hover:text-[#00C7A5]/15 transition-colors leading-none">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>

        {/* CTA banner */}
        <div className="reveal mt-16 lg:mt-20 bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col md:flex-row items-center gap-6 md:gap-8">
          <div className="flex-1">
            <h3 className="text-2xl md:text-3xl font-bold text-[#2F5887] mb-2">
              Pronto para elevar a gestão contábil da sua empresa?
            </h3>
            <p className="text-[#4B5563]">
              Fale com um especialista da Master Business e descubra o que podemos fazer pelo seu negócio.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              data-testid="differentials-whatsapp-cta"
              href={COMPANY.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white font-semibold uppercase tracking-wide px-6 py-3.5 rounded-full transition-all hover:-translate-y-0.5"
            >
              <Icons.MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
            <button
              data-testid="differentials-contact-cta"
              onClick={() => document.getElementById("contatos")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center justify-center gap-2 bg-[#00C7A5] hover:bg-[#00A88A] text-white font-semibold uppercase tracking-wide px-6 py-3.5 rounded-full transition-all hover:-translate-y-0.5"
            >
              Solicitar contato
              <Icons.ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
